import type { BrandConfig } from '@shared/ui/brand';
import LoggedOutHome from './LoggedOutHome';

/** TippingIQ brand package (ADR-0008): labels, layout variants and features. Colours live in theme.css. */
export const brand: BrandConfig = {
  id: 'tiq',
  name: 'TippingIQ',
  tagline: 'Punt like a Pro, without the know!',
  logo: <img src="/tippingiq_transparent.svg" alt="TippingIQ" />,
  markName: 'Prime Pick',
  locksName: "Tippa's Picks",
  valueName: 'Value Radar',
  runnerCard: 'header',
  bestBet: 'tint',
  upcomingShown: 2,
  features: { highProbability: true, tour: true, publicRacingPages: true },
  loggedOutHome: LoggedOutHome,
  chat: { title: 'Chat with Tippa', intro: "Questions, ideas or something not right? Send a message and we'll reply here." },
};
